import React from 'react';
import Icon from '../atoms/Icon';

function AgentIcon(props: any, ref: React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 30 32">
      <g fill='currentColor' fillRule='evenodd'>
        <path d="M12.5714 24V32H10.2857V24H12.5714ZM19.4286 24V32H17.1429V24H19.4286ZM17.1429 4.57143C17.1429 3.3089 16.1197 2.28571 14.8571 2.28571C13.5946 2.28571 12.5714 3.3089 12.5714 4.57143C12.5714 5.83396 13.5946 6.85714 14.8571 6.85714C16.1197 6.85714 17.1429 5.83396 17.1429 4.57143ZM19.4286 4.57143C19.4286 5.78928 18.9504 6.89387 18.1741 7.71317C20.2846 8.88235 21.7143 11.1311 21.7143 13.7143V20.5714H19.4286V13.7143C19.4286 11.19 17.3814 9.14286 14.8571 9.14286C12.3329 9.14286 10.2857 11.19 10.2857 13.7143V20.5714H8V13.7143C8 11.1314 9.42904 8.88249 11.5391 7.71317C10.7631 6.89393 10.2857 5.789 10.2857 4.57143C10.2857 2.04653 12.3322 0 14.8571 0C17.382 0 19.4286 2.04653 19.4286 4.57143Z"/>
        <path d="M29.7143 19.4286V21.7143H0V19.4286H29.7143Z"/>
        <path d="M4.57143 14.8571V26.2857H2.28571V14.8571H4.57143Z"/>
        <path d="M27.4286 14.8571V26.2857H25.1429V14.8571H27.4286Z"/>
      </g>
    </Icon>
  );
}

export default React.forwardRef(AgentIcon);